export default __webpack_public_path__ + "ca0db775c6aa28ce1e4ff268cb239375.png";